import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Card, Space, Row, Col, Form, Input, Checkbox, Button, Image, Flex } from 'antd';
import { LockOutlined, RetweetOutlined, SyncOutlined } from '@ant-design/icons';
import LoginImage from '../assets/images/Login.png';
import SignupImage from '../assets/images/Signup.png';
import { API } from '../components/Initilization'
import { useNavigate } from 'react-router-dom';
import { useNotificationContext } from '../components/NotificationContext'
import "../assets/css/contact-us.css"





const LoginSignUp = () => {
  const navigate = useNavigate();
  const { CallBackUrl } = useParams();
  useEffect(() => {

    RefreshCaptcha()
  }, []);
  const notif = useNotificationContext();
  const [loginCard, setloginCard] = useState(true);
  const [signUpOTPStep, setsignUpOTPStep] = useState(false);
  const [passwordInputType, setpasswordInputType] = useState("password");
  const [Captcha, setCaptcha] = useState("");

  const ChangeCard = () => {
    setloginCard(!loginCard)
  }

  const SignupFormSubmit = (formValues) => {
    if (formValues.SignupPassword != formValues.SignupRePassword) {
      notif.open({
        type: 'error',
        message: 'خطا',
        style: { width: "450px" },
        className: "fYekan-bold",
        placement: 'topRight',
        description: 'رمز عبور با تکرار آن یکسان نیست',
      });
    }
    else {

      var bodyFormData = new FormData();
      bodyFormData.append("username", formValues.SignupPhoneNumber)
      bodyFormData.append("password", formValues.SignupPassword)
      bodyFormData.append("Captcha", document.getElementById("SignupCaptcha").value)
      API.post('/api/account/sign-up', bodyFormData)
        .then(function (response) {
          debugger;
          if (response.status == 200 && response.data.ResultCode == 200) {
            notif.open({
              type: 'success',
              style: { width: "450px" },
              className: "fYekan-bold",
              placement: 'topRight',
              message: 'موفق',
              description: 'کد ارسال شده به شماره همراه خود را وارد کنید',
            });

            setsignUpOTPStep(!signUpOTPStep)

          }
          RefreshCaptcha()
        })
        .catch((error) => {
          RefreshCaptcha()
        });
    }
  }

  const LoginFormSubmit = (formValues) => {

    var bodyFormData = new FormData();
    bodyFormData.append("username", formValues.LoginPhoneNumber)
    bodyFormData.append("password", formValues.LoginPassword)
    bodyFormData.append("Captcha", document.getElementById("LoginCaptcha").value)
    API.post('/api/account/login', bodyFormData)
      .then((response) => {
        debugger;
        if (response.status == 200 && response.data.ResultCode == 200) {
  
          localStorage.setItem('access_token', response.data.Obj.access);
          localStorage.setItem('refresh_token', response.data.Obj.refresh);
          axios.defaults.headers.common['Authorization'] =
            `Bearer ${response.data.Obj.access}`;  // Fixed: use response.data.Obj.access instead of response.data.access
          
          // Dispatch auth changed event to update navbar
          window.dispatchEvent(new Event('authChanged'));
          
          notif.open({
            type: 'success',
            style: { width: "450px" },
            className: "fYekan-bold",
            placement: 'topRight',
            message: 'موفق',
            description: 'ورود شما موفقیت آمیز بود',
          });
  
          if (CallBackUrl != null && CallBackUrl != "") {
            navigate("/" + CallBackUrl);
            
          } else {
            navigate("/");
          }
  
        }
        RefreshCaptcha()
      })
      .catch((error) => {
        RefreshCaptcha()
      });
  
  }
  const EditSignUpInfo = () => {
    setsignUpOTPStep(!signUpOTPStep)
  }

  const otpInput = (text) => {
    var bodyFormData = new FormData();
    bodyFormData.append("username", document.getElementById("SignupPhoneNumber").value)
    bodyFormData.append("code", text)
    API.post('/api/account/activate', bodyFormData)
      .then(function (response) {
        debugger;
        if (response.status == 200 && response.data.ResultCode == 200) {
          notif.open({
            type: 'success',
            style: { width: "450px" },
            className: "fYekan-bold",
            placement: 'topRight',
            message: 'موفق',
            description: 'حساب شما با موفقیت ایجاد شد',
          });
          setsignUpOTPStep(!signUpOTPStep)
          setloginCard(!loginCard)

        }
        RefreshCaptcha()
      })
      .catch((error) => {
        RefreshCaptcha()
      });
  };

  const RefreshCaptcha = () => {
    API.get('/api/company/create-captcha')
      .then(function (response) {
        if (response.status == 200) {
          setCaptcha("data:image/png;base64, " + response.data.CaptchaImg)
        }
      })
      .catch((error) => console.log(error));
  };

  const validatePhoneNumber = (_, value) => {
    // Checks if the value consists only of digits.  
    if (!value || /^[0-9]*$/.test(value)) {
      return Promise.resolve();
    }
    return Promise.reject(new Error("شماره همراه معتبر نیست"));
  };

  const handleMouseDown = () => {
    setpasswordInputType("text");
  };

  const handleMouseUp = () => {
    setpasswordInputType("password");
  };

  const handleTouchStart = () => {
    setpasswordInputType("text");
  };

  const handleTouchEnd = () => {
    setpasswordInputType("password");
  };


  return (
    <Row align={"center"}>
      <Col span={24} style={{ maxWidth: "1200px" }}>
        <Card
          bodyStyle={{ padding: "8px" }}
          className="fEstedad light-glass-effect-card shaped-border"
          title="ورود به حساب"
          style={{ display: loginCard ? "flex" : "none", flexDirection: 'column', justifyContent: 'center'}} // Adjust minHeight as needed  
        >
          <Row style={{ flex: 1, alignItems: 'center' }}>
            <Col order={1} align={"center"} span={24} lg={0}>
              <img className="smooth-shadow-img" src={LoginImage} width={270} alt="Login" />
            </Col>
            <Col order={1} span={24} lg={12}>
              <Flex align="center" justify="center">
                <Form
                  onFinish={LoginFormSubmit}
                  name="layout-multiple-vertical"
                  layout="vertical"
                  className="fEstedad"
                >
                  <Form.Item rules={[
                    {
                      validator: validatePhoneNumber,
                    },
                  ]} label="شماره همراه" name="LoginPhoneNumber">
                    <Input style={{ direction: "ltr", height:"40px", paddingTop:"0px" }} prefix={<p style={{ marginTop:"22px" }}> +98 </p> } />
                  </Form.Item>
                  <Form.Item label="رمز عبور" name="LoginPassword">
                    <Input type={passwordInputType} style={{paddingTop:"0px", height:"40px",  direction: "ltr"}} prefix={<LockOutlined
                      onMouseDown={handleMouseDown}
                      onMouseUp={handleMouseUp}
                      onMouseLeave={handleMouseUp}
                      onTouchStart={handleTouchStart}
                      onTouchEnd={handleTouchEnd}
                    />} />
                  </Form.Item>
                  <Form.Item style={{ position: "relative", direction: "ltr" }} label="کپچا" name="LoginCaptcha">
                    <Image style={{ position: "absolute", top: "-13px", left: "3px", width: "102px", zIndex: "50", borderRadius: "8px" }} src={Captcha} />
                    <Input id="LoginCaptcha" style={{paddingTop:"0px", height:"40px",  direction: "rtl"}} prefix={<SyncOutlined onClick={RefreshCaptcha} style={{ cursor: "pointer" }} />} />
                  </Form.Item>
                  <Form.Item name="remember" valuePropName="checked">
                    <Checkbox>مرا بخاطر بسپار</Checkbox>
                  </Form.Item>
                  <Form.Item>
                    <Row gutter={[24, 24]} style={{ flex: 1, alignItems: 'center' }}>
                      <Col align={"center"} span={24} md={12}>
                        <Button color="text" variant="outlined">فراموشی رمز عبور</Button>
                      </Col>
                      <Col align={"center"} span={24} md={12}>
                        <Button htmlType="submit" type="primary">ورود</Button>
                      </Col>
                    </Row>
                  </Form.Item>
                  <Form.Item>
                    <Space size="large" style={{ justifyContent: 'center', width: '100%' }}>
                      <Button onClick={ChangeCard} type="secondary">ثبت نام در سایت</Button>
                    </Space>
                  </Form.Item>
                </Form>
              </Flex>
            </Col>
            <Col order={2} align={"center"} span={0} lg={12}>
              <Image className="smooth-shadow-img" src={LoginImage} preview={false} />
            </Col>
          </Row>
        </Card>



        <Card
          isVisible={false}
          styles={{}}
          className="fEstedad light-glass-effect-card shaped-border"
          title="عضویت در سایت"
          style={{ display: !loginCard ? "flex" : "none", flexDirection: 'column', justifyContent: 'center'}} // Adjust minHeight as needed  
        >
          <Row style={{ flex: 1, alignItems: 'center' }}>
            <Col order={1} align={"center"} span={24} lg={0}>
              <img src={SignupImage} className="smooth-shadow-img" width={270} alt="Login" />
            </Col>
            <Col order={1} span={24} lg={12}>
              <Flex align="center" justify="center">
                <Form
                  onFinish={SignupFormSubmit}
                  style={{ display: signUpOTPStep ? "none" : "block" }}
                  name="layout-multiple-vertical"
                  layout="vertical"

                  className="fEstedad"
                >
                  <Form.Item
                    rules={[
                      {
                        validator: validatePhoneNumber,
                      },
                    ]}
                    label="شماره همراه" name="SignupPhoneNumber">
                    <Input id="SignupPhoneNumber" style={{ direction: "ltr", height:"40px", paddingTop:"0px" }} prefix={<p style={{ marginTop:"22px" }}> +98 </p> } />
                  </Form.Item>
                  <Form.Item label="رمز عبور" name="SignupPassword">
                    <Input type={passwordInputType} style={{paddingTop:"0px", height:"40px",  direction: "ltr"}} prefix={<LockOutlined
                      onMouseDown={handleMouseDown}
                      onMouseUp={handleMouseUp}
                      onMouseLeave={handleMouseUp}
                      onTouchStart={handleTouchStart}
                      onTouchEnd={handleTouchEnd}
                    />} />
                  </Form.Item>
                  <Form.Item label="تکرار رمز عبور" name="SignupRePassword">
                    <Input style={{paddingTop:"0px", height:"40px",  direction: "ltr"}} type={passwordInputType}  prefix={<RetweetOutlined
                      onMouseDown={handleMouseDown}
                      onMouseUp={handleMouseUp}
                      onMouseLeave={handleMouseUp}
                      onTouchStart={handleTouchStart}
                      onTouchEnd={handleTouchEnd} />} />
                  </Form.Item>
                  <Form.Item style={{ position: "relative", direction: "ltr" }} label="کپچا" name="SignupCaptchaValidation">
                    <Image style={{ position: "absolute", top: "-13px", left: "3px", width: "102px", zIndex: "50", borderRadius: "8px" }} src={Captcha} />
                    <Input style={{paddingTop:"0px", height:"40px"}} id="SignupCaptcha" prefix={<SyncOutlined onClick={RefreshCaptcha} style={{ cursor: "pointer" }} />} />
                  </Form.Item>
                  <Form.Item>
                    <Row gutter={[24, 24]} style={{ flex: 1, alignItems: 'center' }}>
                      <Col align={"center"} span={24} md={12}>
                      <Button onClick={ChangeCard} type="secondary">صفحه ی ورود</Button>
                      </Col>
                      <Col align={"center"} span={24} md={12}>
                      <Button htmlType="submit" type="primary">عضویت</Button>
                      </Col>
                    </Row>
                 
                  </Form.Item>

                </Form>
                <Form
                  style={{ display: !signUpOTPStep ? "none" : "block" }}
                  name="layout-multiple-vertical"
                  layout="vertical"
                  className="fEstedad"
                >  <Flex align="center" justify="center">
                    <Form.Item label="کد ارسال شده" name="OTP">

                      <Input.OTP length={4} onChange={otpInput} dir="ltr" />

                    </Form.Item>
                  </Flex>
                  <Form.Item>
                    <Space size={"large"} style={{ width: '100%', justifyContent: 'center' }}>
                      <Button onClick={EditSignUpInfo} type="secondary">ویرایش شماره</Button>
                      <Button type="primary">تایید</Button>
                    </Space>
                  </Form.Item>

                </Form>
              </Flex>
            </Col>
            <Col order={2} align={"center"} span={0} lg={12}>
              <Image className="smooth-shadow-img" src={SignupImage} preview={false} />
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  );
};

export default LoginSignUp;  